import React from 'react';
import { Link } from 'react-router-dom';

import styled from 'styled-components';

import OverviewCommunitiesAvatar from './OverviewCommunitiesAvatar';
import { ACTOR_TYPE } from '../../constants';
import { COMPANY_COMMUNITY_RELATION_TYPE } from '../../constants/company';

const CommunityCell = styled.div`
  display: flex;
  flex-direction: row;
  line-height: normal;
  padding-left: 10px;
  gap: 10px;
`;

const CommunityCellInfo = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--text-primary);
`;

const StyledLink = styled(Link)`
  font-family: var(--font-bold);
  font-size: 14px;
  color: var(--text-primary);
`;

const CommunityAddress = styled.span`
  font-size: 12px;
`;

interface Props {
  record: any;
}

const OverviewCommunitiesInfo = ({ record }: Props) => {
  const linkPrefix =
    record?.company_relation_type === COMPANY_COMMUNITY_RELATION_TYPE.COMMUNITY
      ? ACTOR_TYPE.COMMUNITY
      : ACTOR_TYPE.COMPETITOR;

  return (
    <CommunityCell>
      <OverviewCommunitiesAvatar name={record?.comunity_name} type={record?.company_relation_type} />
      <CommunityCellInfo>
        <StyledLink to={`/${linkPrefix}/${record.id}`}>{record?.comunity_name}</StyledLink>
        <CommunityAddress>{record?.address}</CommunityAddress>
      </CommunityCellInfo>
    </CommunityCell>
  );
};

export default OverviewCommunitiesInfo;
